import { render, staticRenderFns } from "./SignUp-Payment.vue?vue&type=template&id=e913a9a8&"
import script from "./SignUp-Payment.vue?vue&type=script&lang=js&"
export * from "./SignUp-Payment.vue?vue&type=script&lang=js&"
import style0 from "./SignUp-Payment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports